import React from 'react';

import Field from '../../Fields/Field';
import InputDateField from '../../Fields/InputDateField';

import useReport from '../../../Hooks/useReport';

import SignUpTerminationReport from '../../../Utils/signUpTerminationReport'

import './SignUpTerminationReport.scss';
import ActionButton from '../../Common/ActionButton';

function SignUpTerminationReportForm({ facilityId }) {
  const {
    filterValues,
    downloadCSVReport,
    inputOnChange,
    resetFilters,
    isDownloadingCSV
  } = useReport(SignUpTerminationReport, facilityId);

  return (
    <div className="parkchirp--signup-termination-report--filter-form-container">
      <div className="parkchirp--signup-termination-report--filter-form">
        <h2>Sign Up / Termination Report</h2>
        <div className="parkchirp--signup-termination-report--filter-inputs">
          <div className="parkchirp--signup-termination-report--filter-input-block">
          </div>
        </div>
        <div className="parkchirp--signup-termination-report--filter-inputs">
          <div className="parkchirp--signup-termination-report--filter-input-block">
            <Field label="Parker Start Date"
              id="parkchirp--transactions-report-filter--parker-start-date"
              layout="columns">
              <InputDateField inputId="parkchirp--transactions-report-filter--parker-start-date"
                value={filterValues.parkerStartDate}
                onChange={inputOnChange('parkerStartDate')}
                editMode={true}
              />
            </Field>
            <Field label="Parker End Date"
              id="parkchirp--transactions-report-filter--parker-end-date"
              layout="columns">
              <InputDateField inputId="parkchirp--transactions-report-filter--parker-end-date"
                value={filterValues.parkerEndDate}
                onChange={inputOnChange('parkerEndDate')}
                editMode={true}
              />
            </Field>
          </div>
          <div className="parkchirp--signup-termination-report--filter-input-block">
            <Field label="Transaction Start Date"
              id="parkchirp--transactions-report-filter--transaction-start-date"
              layout="columns">
              <InputDateField inputId="parkchirp--transactions-report-filter--transaction-start-date"
                value={filterValues.transactionStartDate}
                onChange={inputOnChange('transactionStartDate')}
                editMode={true}
              />
            </Field>
            <Field label="Transaction End Date"
              id="parkchirp--transactions-report-filter--transaction-end-date"
              layout="columns">
              <InputDateField inputId="parkchirp--transactions-report-filter--transaction-end-date"
                value={filterValues.transactionEndDate}
                onChange={inputOnChange('transactionEndDate')}
                editMode={true}
              />
            </Field>
          </div>
        </div>
        <div className="parkchirp--signup-termination-report--filter-actions">
          <ActionButton label="Download Sign Up / Termination Report"
            classNames={[ "button", "button-primary parkchirp--signup-termination-report--filter-action" ]}
            onClick={() => downloadCSVReport()}
            inProgressState={isDownloadingCSV}
          />
          <button type="button"
            className="button parkchirp--signup-termination-report--filter-action"
            onClick={resetFilters}
            >
            Reset
          </button>
        </div>
      </div>
    </div>
  )
}

export default React.memo(SignUpTerminationReportForm);